import React from 'react';
import { Tag } from 'antd';
import {
  promotionTypeColor,
  promotionTypeLabel,
} from '../../utils/shopPromotionLabels';
import type { ShopPromotionType } from '../../types/shopPromotion';

export const PromotionTypeTag: React.FC<{
  type: ShopPromotionType | string;
}> = ({ type }) => (
  <Tag color={promotionTypeColor(type)}>{promotionTypeLabel(type)}</Tag>
);
